import { Component } from '@angular/core';

@Component({
    selector: 'gforge-logo',
    template: `<svg version="1.1" class="logo-gforge" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px" viewBox="0 0 640 117">
    <g>
        <g>
            <path class="gforge-logo__accent" d="M70.5,25.5c-7-1.5-11.4-8.4-10-15.4c1.5-7,8.4-11.4,15.4-10c7,1.5,11.4,8.4,10,15.4
                       C84.3,22.5,77.4,27,70.5,25.5z M74.2,7.9c-2.7-0.6-5.4,1.2-6,3.9c-0.6,2.7,1.2,5.4,3.9,6c2.7,0.6,5.4-1.2,6-3.9
                       C78.7,11.2,76.9,8.5,74.2,7.9z" />
        </g>
        <g>
            <path class="gforge-logo__accent"
                d="M30.8,71.3c-15.4,0-28-12.5-28-28c0-15.4,12.5-28,28-28c15.4,0,28,12.5,28,28C58.7,58.8,46.2,71.3,30.8,71.3
                       z M30.8,23.3c-11.1,0-20.1,9-20.1,20.1c0,11.1,9,20.1,20.1,20.1c11.1,0,20.1-9,20.1-20.1C50.8,32.3,41.8,23.3,30.8,23.3z" />
        </g>
        <g>
            <path class="gforge-logo__accent" d="M43.2,117.1c-11.3,0-20.6-9.2-20.6-20.6c0-11.3,9.2-20.6,20.6-20.6c11.3,0,20.6,9.2,20.6,20.6
                       C63.8,107.9,54.6,117.1,43.2,117.1z M43.2,83.8c-7,0-12.7,5.7-12.7,12.7c0,7,5.7,12.7,12.7,12.7c7,0,12.7-5.7,12.7-12.7
                       C55.9,89.5,50.2,83.8,43.2,83.8z" />
        </g>
        <path class="gforge-logo__prime" d="M61.3,17.9L52,25.2c1.7,2,3.1,4.2,4.2,6.7l10.2-8C64.1,22.5,62.3,20.4,61.3,17.9z M22.7,94.9
                     c-8.3-0.7-14.9-7.7-14.9-16.1c0-4.8,2.1-9.3,5.8-12.4l0.6-0.4c-2.2-1.6-4.1-3.5-5.7-5.6C3.1,64.9,0,71.6,0,78.7
                     c0,13.1,10.6,23.8,23.6,24.1c-0.6-2-1-4.1-1-6.3C22.7,96,22.7,95.4,22.7,94.9z" />
    </g>
    <g>
        <path class="gforge-logo__accent"
            d="M143.9,61.1h8.7v17.7c-4.9,5.4-11.9,8.1-20.9,8.1c-7.6,0-14-2.5-19.2-7.5c-5.2-5-7.7-11.4-7.7-19.1
                     c0-7.7,2.6-14.1,7.9-19.2c5.3-5.1,11.6-7.7,19-7.7c7.4,0,13.6,2.2,18.6,6.5l-4.7,6.7c-2-1.7-4.1-2.9-6.1-3.6c-2-0.7-4.4-1-7.1-1
                     c-5.2,0-9.6,1.7-13.2,5.1c-3.6,3.4-5.3,7.8-5.3,13.3c0,5.5,1.7,9.9,5.2,13.2c3.5,3.3,7.6,5,12.5,5c4.9,0,9-1.1,12.3-3.2V61.1z" />
        <path class="gforge-logo__prime" d="M217.3,42.7v14.2h22.9v8.1h-22.9v21.3h-8.7V34.5H243l-0.1,8.1H217.3z" />
        <path class="gforge-logo__prime" d="M340.9,79.1c-5.2,5.1-11.7,7.7-19.4,7.7c-7.7,0-14.2-2.6-19.4-7.7c-5.2-5.1-7.8-11.5-7.8-19.1
                     s2.6-14,7.8-19.1c5.2-5.1,11.7-7.7,19.4-7.7c7.7,0,14.2,2.6,19.4,7.7c5.2,5.1,7.8,11.5,7.8,19.1S346.1,74,340.9,79.1z M334.5,46.7
                     c-3.5-3.6-7.9-5.5-13-5.5c-5.1,0-9.5,1.8-13,5.5c-3.5,3.7-5.3,8.1-5.3,13.3c0,5.2,1.8,9.6,5.3,13.3c3.5,3.7,7.9,5.5,13,5.5
                     c5.1,0,9.5-1.8,13-5.5c3.5-3.6,5.3-8.1,5.3-13.3C339.8,54.8,338,50.4,334.5,46.7z" />
        <path class="gforge-logo__prime" d="M445.4,51.3c0,8.5-3.7,13.9-11.2,16.1l13.5,18.8h-11.1l-12.4-17.4h-11.5v17.4h-8.7V34.5h19.2
                     c7.9,0,13.5,1.3,16.9,4C443.7,41.2,445.4,45.5,445.4,51.3z M433.8,58.7c1.8-1.5,2.7-4,2.7-7.4c0-3.4-0.9-5.7-2.7-7
                     c-1.8-1.3-5.1-1.9-9.8-1.9h-11.1v18.5h10.9C428.7,60.9,432,60.2,433.8,58.7z" />
        <path class="gforge-logo__prime"
            d="M538.2,61.1h8.7v17.7c-4.9,5.4-11.9,8.1-20.9,8.1c-7.6,0-14-2.5-19.2-7.5c-5.2-5-7.7-11.4-7.7-19.1
                     c0-7.7,2.6-14.1,7.9-19.2c5.3-5.1,11.6-7.7,19.1-7.7c7.4,0,13.6,2.2,18.6,6.5l-4.7,6.7c-2-1.7-4.1-2.9-6.1-3.6c-2-0.7-4.4-1-7.1-1
                     c-5.2,0-9.6,1.7-13.2,5.1c-3.5,3.4-5.3,7.8-5.3,13.3c0,5.5,1.7,9.9,5.2,13.2c3.5,3.3,7.6,5,12.5,5c4.9,0,9-1.1,12.3-3.2V61.1z" />
        <path class="gforge-logo__prime" d="M639.1,34.5v8.2h-27.6v13.7h24.8v7.8h-24.8V78H640v8.2h-37.2V34.5H639.1z" />
    </g>
</svg>`
})
export class GForgeLogoComponent { }
